module.exports = __webpack_public_path__ + "assets/5e2d727763d1156803a5dd6f6be643f5.png";